// Exports a Model Studio cuboid document as a binary GLB using the engine's
// pure doc-to-Group mapping plus three's GLTFExporter.
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';

// Imported from the concrete engine path, not the published `../../engine`
// barrel: buildModelGroup pulls in three-bvh-csg/three-mesh-bvh (via
// modelCsg.ts), which every published-library consumer would otherwise pay
// for even though only this Studio-only export path uses it.
import { buildModelGroup, type ModelGroupElement } from '../../engine/content/model/modelGroup';

/** Build the authored cuboids into a scene and export it as binary GLB bytes. */
export async function exportModelGlb(elements: ModelGroupElement[]): Promise<ArrayBuffer> {
  const group = buildModelGroup(elements);
  const exporter = new GLTFExporter();
  const result = await exporter.parseAsync(group, { binary: true });
  if (result instanceof ArrayBuffer) return result;
  throw new Error('GLB export did not produce binary output.');
}
